import { createAsyncThunk, createSlice, original } from "@reduxjs/toolkit";
import { getRankerProperties } from "./rankerApi";
import { setGlobalMsgAlerts } from "../../components/GloablMsgAlerts/globalMsgAlertsSlice";
import { isAxiosError } from "axios";
import { errorMessages } from "../../common_variables/ErrorMsgs";

interface stateType {
  loading: boolean;
  properties: {
    moleculeData: any | null;
    statsSummary: any | null;
    interactionsSet: [];
    singleSmileData: {
      id: number;
      rankRowData: any[];
      evaluationIds: number[];
      data: any;
      jobId: string;
    };
    jobId: string;
  };
}

const initialState: stateType = {
  loading: false,
  properties: {
    moleculeData: null,
    statsSummary: null,
    interactionsSet: [],
    singleSmileData: {
      id: -1,
      rankRowData: [],
      evaluationIds: [],
      data: null,
      jobId: "",
    },
    jobId: "",
  },
};

export const fetchRankerProperties = createAsyncThunk(
  "ranker/fetchRankerProperties",
  async (
    {
      task_id,
      maimol_id,
      uid,
    }: {
      task_id?: string;
      maimol_id?: string;
      uid?: string;
    },
    { dispatch }
  ) => {
    try {
      const response = await getRankerProperties({
        task_id,
        maimol_id,
        uid,
      });
      return response.data;
    } catch (error) {
      let msg = "";
      if (isAxiosError(error)) {
        msg = error.response.data?.detail?.message;
      }
      dispatch(
        setGlobalMsgAlerts({
          msg: msg || errorMessages.jobResultError,
          isAlert: true,
          color: "error",
        })
      );
      throw error;
    }
  }
);

export const rankerSlice = createSlice({
  name: "ranker",
  initialState,
  reducers: {
    setSingleSmileData: (state, action) => {
      state.properties.singleSmileData.id = action.payload.id;
      state.properties.singleSmileData.rankRowData = action.payload.rankRowData;
      state.properties.singleSmileData.evaluationIds =
        action.payload.evaluationIds;
      state.properties.singleSmileData.data = action.payload.data;
      state.properties.singleSmileData.jobId = action.payload.jobId;
    },
    updateSmilesById: (state, action) => {
      const { id } = action.payload;
      const sliceData = original(state.properties.singleSmileData);
      const smilesData = sliceData.rankRowData[sliceData.evaluationIds[id] - 1];
      state.properties.singleSmileData.id = id;
      state.properties.singleSmileData.data = smilesData;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRankerProperties.fulfilled, (state, action) => {
        state.properties.moleculeData = action.payload.moleculeData;
        state.properties.statsSummary = action.payload.statsSummary;
        state.properties.interactionsSet =
          action.payload.interactions_set.sort();
        state.properties.jobId = action.payload.job_id;
        state.loading = false;
      })
      .addCase(fetchRankerProperties.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchRankerProperties.pending, (state) => {
        state.loading = true;
      });
  },
});
export const { setSingleSmileData, updateSmilesById } = rankerSlice.actions;
export default rankerSlice.reducer;
